'use client';

import { initializeApp, getApps } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { firebaseConfig, appCheckConfig } from "./config";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Initialize Firebase app
export const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Check if the app is running locally (localhost or 127.0.0.1)
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// Use debug token only if running locally
if (isLocalhost) {
  // const useDebugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN === "true";
  // console.log(useDebugToken);
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
console.log("App Check Key", appCheckConfig)
// Initialize App Check with reCAPTCHA Enterprise provider
const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(appCheckConfig.reCaptchaEnterpriseSiteKey),
  isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
});

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
